import { memo, useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectIceberg, selectOrderType, selectStrategyBuilderMode, selectStrategyBuilderTradingAccountId, selectStrategyInfo, selectTargetValues, selectTradeOrders, selectTradeProduct } from "../../selectors/strategyBuilder";
import { selectPrimaryTradingAccount, selectTradingAccounts } from "../../selectors/user";
import { Broker_Variety, MarginFromBrokerRequest, MarginFromBrokerResponse } from "../../proto/generated/order";
import { getRequiredMarginFromBroker } from "../../services/apis/tradingAccount";
import { useDispatch } from "react-redux";
import { updateStrategyInfo } from "../../reducer/strategyBuilder.reducer";
import StrategyInfoDisplay from "./strategyInfoDisplay";
import { debounce } from "throttle-debounce";
import { selectPrimarySecurity } from "../../selectors/home";

const LiveStrategyInfo: React.FC = () => {
    const dispatch = useDispatch();
    const mode = useSelector(selectStrategyBuilderMode);
    const tradeOrders = useSelector(selectTradeOrders);
    const orderType = useSelector(selectOrderType);
    const product = useSelector(selectTradeProduct);
    const iceberg = useSelector(selectIceberg);
    const tradingAccounts = useSelector(selectTradingAccounts)
    const strategyTradingAccountId = useSelector(selectStrategyBuilderTradingAccountId);
    const selectedTradingAccount = useSelector(selectPrimaryTradingAccount);
    const strategyInfo = useSelector(selectStrategyInfo);
    const { spotBasePrice } = useSelector(selectTargetValues)
    const { underlying } = useSelector(selectPrimarySecurity)
    const tradingAccount = useMemo(() => {
        if (mode !== 'trade') {
            return tradingAccounts.find(t => t.accountId === strategyTradingAccountId) ?? selectedTradingAccount
        }
        return selectedTradingAccount
    }, [mode, selectedTradingAccount, strategyTradingAccountId, tradingAccounts])

    const fetchMargin = useCallback(debounce(100, async (request: MarginFromBrokerRequest) => {
        const response = await getRequiredMarginFromBroker({ request});
        dispatch(updateStrategyInfo({
            totalMargin: response.totalMargin,
            brokerCharges: response.brokerCharges,
            costBreakdown: response.costBreakdown
        }));
    }), []);

    useEffect(() => {

        if (!tradingAccount || !tradeOrders.length) return;
        const legMultiplier = iceberg.enabled ? Math.max(1, iceberg.numberOfLegs ?? 1) : 1;
        const request: MarginFromBrokerRequest = {
            orders: tradeOrders.map((tO, i) => {

            return {
                security: {
                    exchange: tO.security.exchange,
                    code: tO.security.code
                },
                transactionType: tO.transactionType,
                orderType,
                position: tO.quantity * legMultiplier,
                product,
                price: tO.price,
                variety: Broker_Variety.REGULAR,
                exchange: tO.security.exchange,
                strikePrice: tO.security.strikePrice,
                expiry: tO.security.expiry?.expiry,
                optionType: tO.security.optionType

            }
        }),
            tradingAccount: {
                accountId: tradingAccount.accountId,
                brokerId: tradingAccount.brokerCode
            }
        }

        fetchMargin(request);
    }, [tradingAccount, tradeOrders, orderType, product, iceberg.enabled, iceberg.numberOfLegs])

    return <StrategyInfoDisplay info={strategyInfo} simulator={false} spotPrice={spotBasePrice ? spotBasePrice/(underlying?.priceMultiplier??100) : undefined} />;
}


export default memo(LiveStrategyInfo)